import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DatabaseEnvPageRoutingModule } from './database-env.routing.module';

import { SharedModule } from '../shared/shared.module';
import { DatabaseEnvPage } from './database-env';
import { AddDatabaseEnvComponent } from './add-database-env/add-database-env.component';
import { UpdateDatabaseEnvComponent } from './update-database-env/update-database-env.component';
import { DatabaseEnvDetailsComponent } from './database-env-details/database-env-details.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    DatabaseEnvPageRoutingModule
  ],
  declarations: [DatabaseEnvPage, AddDatabaseEnvComponent, UpdateDatabaseEnvComponent, DatabaseEnvDetailsComponent]
})
export class DatabaseEnvPageModule {}
